import {linkClick} from '../events'
import withSnowplowLifecycle from './withSnowplowLifecycle'

const withLinkClickEvent = (WrappedComponent, options = null) => withSnowplowLifecycle(WrappedComponent, linkClick, options)

export default withLinkClickEvent
